import { PropsWithChildren } from "react"

const TableWithControls = ({ children }: PropsWithChildren) => {
    return (
        <div className='ted-ui-TableWithControls' >
            {children}
        </div>
    )
}

export default TableWithControls